module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/13FQM6x/tc-custom/9780814708118.jpg?1726429835811",
      "alt": "This image is the cover for the book Signifying Creator"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Signifying Creator\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("For centuries, Jews have been known as the \"people of the book.\" It is commonly thought that Judaism in the first several centuries CE found meaning exclusively in textual sources. But there is another approach to meaning to be found in ancient Judaism, one that sees it in the natural world and derives it from visual clues rather than textual ones. According to this conception, God embedded hidden signs in the world that could be read by human beings and interpreted according to complex systems."), _c('br'), _c('br'), _vm._v("In exploring the diverse functions of signs outside of the realm of the written word, Swartz introduces unfamiliar sources and motifs from the formative age of Judaism, including magical and divination texts and new interpretations of legends and midrashim from classical rabbinic literature.  He shows us how ancient Jews perceived these signs and read them, elaborating on their use of divination, symbolic interpretation of physical features and dress, and interpretations of historical events. As we learn how these ancient people read the world, we begin to see how ancient people found meaning in unexpected ways.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael D Swartz\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    New York University Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0